<template>
  <div class="flex flex-col items-center justify-center">
    <img src="@/assets/images/conditional-order.svg" alt="conditional_order" />

    <NText weight="bold" class="py-3 text-neutral-secondary">
      {{ t('orders.conditional.whatAreConditionalTrading') }}
    </NText>

    <NText variant="caption1">
      {{ t('orders.conditional.conditionalOrderDescription') }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
